module.exports = __webpack_public_path__ + "img/stream-mobile-tip@2x.2ce485fd.png";